/**
 * Theme Foundation Configuration
 * Core theme properties: spacing, breakpoints, shadows, etc.
 */

import { 
  spacing as spacingTokens,
  breakpoints as breakpointTokens,
  shadows as shadowTokens,
  borderRadius,
  duration,
  easing,
} from '../tokens/dimensions';

// Spacing function (MUI uses 8px default)
export const spacing = (factor) => `${spacingTokens[factor] || factor * 8}px`;

// Breakpoints configuration
export const breakpoints = {
  values: breakpointTokens,
  unit: 'px',
};

// Shadows array (MUI expects 25 shadows)
export const shadows = [
  'none', // 0
  shadowTokens.sm, // 1
  shadowTokens.sm, // 2
  shadowTokens.default, // 3
  shadowTokens.default, // 4
  shadowTokens.md, // 5
  shadowTokens.md, // 6
  shadowTokens.md, // 7
  shadowTokens.md, // 8
  shadowTokens.lg, // 9
  shadowTokens.lg, // 10
  shadowTokens.lg, // 11
  shadowTokens.lg, // 12
  shadowTokens.xl, // 13
  shadowTokens.xl, // 14
  shadowTokens.xl, // 15
  shadowTokens.xl, // 16
  shadowTokens['2xl'], // 17
  shadowTokens['2xl'], // 18
  shadowTokens['2xl'], // 19
  shadowTokens['2xl'], // 20
  shadowTokens.dialog, // 21
  shadowTokens.dialog, // 22
  shadowTokens.dialog, // 23
  shadowTokens.dialog, // 24
];

// Shape configuration
export const shape = {
  borderRadius: borderRadius.default,
};

// Transitions configuration
export const transitions = {
  easing: {
    easeInOut: easing.easeInOut,
    easeOut: easing.easeOut,
    easeIn: easing.easeIn,
    sharp: easing.sharp,
  },
  duration: {
    shortest: duration.instant,
    shorter: duration.fast,
    short: duration.normal,
    standard: duration.normal,
    complex: duration.slow,
    enteringScreen: duration.normal,
    leavingScreen: duration.fast,
  },
  // Helper function to create transitions
  create: (props = ['all'], options = {}) => {
    const {
      duration: durationOption = duration.normal,
      easing: easingOption = easing.easeInOut,
      delay = 0,
    } = options;

    return (Array.isArray(props) ? props : [props])
      .map(prop => `${prop} ${durationOption}ms ${easingOption} ${delay}ms`)
      .join(',');
  },
};